import { checkDate } from "common/helpers/Date";
import { Nullable } from "common/types";
import { Record } from "immutable";
import { DateStringNumber } from ".";

export const fromJSON = (json: Partial<IDynamicPresentationLinkData>): DynamicPresentationLinkRecord => {
  const data: IDynamicPresentationLinkRecord = { ...(json as any) };

  if (json.created_at) {
    data.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    data.updated_at = checkDate(json.updated_at);
  }

  return new DynamicPresentationLinkRecord(data);
};

export const toJSON = (record: DynamicPresentationLinkRecord): IDynamicPresentationLinkData => {
  const json = record.toJSON() as IDynamicPresentationLinkData;

  if (json.id <= 0) {
    delete (json as any).id;
  }

  if (json._destroy === false) {
    delete json._destroy;
  }

  return json;
};

export interface IDynamicPresentationLinkData {
  id: number;
  presentation_id: number;
  sort_order: number;
  kind: DynamicPresentationLinkKind;
  presentable_id: number;
  presentable_type: string;
  _destroy?: boolean;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IDynamicPresentationLinkRecord {
  id: number;
  presentation_id: Nullable<number>;
  kind: DynamicPresentationLinkKind;
  presentable_id: Nullable<number>;
  presentable_type: Nullable<string>;
  sort_order: number;
  _destroy: Nullable<boolean>;

  created_at: Date;
  updated_at: Date;
}

const defaultDynamicPresentationLinkProps: IDynamicPresentationLinkRecord = {
  id: 0,
  presentation_id: null,
  presentable_id: null,
  presentable_type: null,
  kind: "default",
  sort_order: 0,
  _destroy: false,
  created_at: new Date(),
  updated_at: new Date(),
};

export class DynamicPresentationLinkRecord
  extends Record(defaultDynamicPresentationLinkProps)
  implements IDynamicPresentationLinkRecord {}

export type DynamicPresentationLinkKind = "default" | "inspection";
